<div class="card card-cliente-revisao mb-3" *ngIf="isRevisaoPendente()">
    <h6 class="card-header card-title">
        <i class="far fa-clipboard"></i> Este cliente possui a revisão pendente
        <span class="badge badge-primary ml-1" *ngIf="entity.cadastroNovo">
            <i class="fas fa-asterisk"></i> Cadastro Novo
        </span>
    </h6>
    <div class="card-body">
        <p *ngIf="isLoadingAtividade">
            <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando atividade da revisão
        </p>

        <ng-template [ngIf]="!isLoadingAtividade && entity?.atividadeRevisaoPendente">
            <div class="row">
                <div class="col-12 col-md mb-2">
                    <label class="col-form-label d-block">Última Revisão</label>
                    <ng-template [ngIf]="entity.dataUltimaRevisao">
                        <div title="Data da última revisão">
                            <i class="far fa-calendar-check"></i> {{entity.dataUltimaRevisao | date: 'dd/MM/yyyy'}} às {{entity.dataUltimaRevisao| date: 'HH:mm'}}
                        </div>
                        <div title="Responsável pela última revisão">
                            <i class="far fa-user"></i> {{entity.usuarioUltimaRevisao?.nome}}
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="!entity.dataUltimaRevisao">
                        <p class="m-0">
                            <i class="far fa-calendar-times"></i> Nenhuma revisão realizada
                        </p>
                    </ng-template>
                </div>
                <div class="col-12 col-md mb-2" *ngIf="entity.atividadeRevisaoPendente.diaPrazo">
                    <label class="col-form-label d-block">Prazo desta Revisão</label>
                    <span [ngClass]="{'badge badge-atividade-atrasada': entity.atividadeRevisaoPendente.atrasada}" [title]="entity.atividadeRevisaoPendente.atrasada ? 'Esta revisão está atrasada' : 'Prazo da revisão'">
                        <i class="far fa-calendar-alt"></i> {{entity.atividadeRevisaoPendente.diaPrazo | date:'dd/MM/yyyy'}} {{entity.atividadeRevisaoPendente.horaPrazo ? 'às ' + (entity.atividadeRevisaoPendente.horaPrazo | date:'HH:mm') : ''}}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="atividadeRevisaoPendenteComentario" class="col-form-label">Comentário</label>
                    <textarea class="form-control" [(ngModel)]="entity.atividadeRevisaoPendente.comentario" name="atividadeRevisaoPendenteComentario" id="atividadeRevisaoPendenteComentario"
                        #atividadeRevisaoComentario="ngModel" rows="2" sgtAutosize>
                    </textarea>
                </div>
            </div>
            <sgt-atividade-checklist-item
                #atividadeChecklistItem
                [idAtividade]="entity.atividadeRevisaoPendente.id"
                [entities]="entity.atividadeRevisaoPendente.checklistItens"
                [(quantidadeChecklistItens)]="entity.atividadeRevisaoPendente.quantidadeChecklistItens"
                [(quantidadeChecklistItensConcluidos)]="entity.atividadeRevisaoPendente.quantidadeChecklistItensConcluidos"
                [(percQuantidadeChecklistItensConcluidos)]="entity.atividadeRevisaoPendente.percQuantidadeChecklistItensConcluidos">
            </sgt-atividade-checklist-item>
        </ng-template>

        <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.revisaoConfirmada" name="revisaoConfirmada" id="revisaoConfirmada">
            <label class="custom-control-label" for="revisaoConfirmada">Confirmo que realizei a revisão deste cliente</label>
        </div>
    </div>
</div>
